(function () {
  'use strict';
  function start() {
    var page = document.querySelector('[data-design-help]');
    if (!page || page.dataset.bound) return;
    page.dataset.bound = 'true';
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var notice = document.createElement('p');
    notice.className = 'dh-add-status'; notice.setAttribute('role', 'status'); notice.hidden = true;
    page.appendChild(notice);
    function readCart() { return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('We could not check your basket.'); return r.json(); }); }
    page.querySelectorAll('[data-design-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('button');
        if (button.disabled) return;
        var label = button.innerHTML;
        button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…';
        notice.hidden = true;
        fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'This service could not be added. Please try again.'); return data; }); })
          .then(function () {
            notice.replaceChildren(document.createTextNode('Added to your basket. '));
            var link = document.createElement('a'); link.href = root + 'cart'; link.textContent = 'View basket'; notice.appendChild(link); notice.hidden = false;
            return readCart().then(function (cart) {
              var anchor = document.querySelector('#cart-icon-bubble');
              if (!anchor) return;
              var count = Number(cart.item_count) || 0;
              anchor.setAttribute('aria-label', count + (count === 1 ? ' item' : ' items'));
              var bubble = anchor.querySelector('.cart-count-bubble');
              if (!bubble && count) {
                bubble = document.createElement('div'); bubble.className = 'cart-count-bubble';
                var visible = document.createElement('span'); visible.setAttribute('aria-hidden', 'true'); bubble.appendChild(visible);
                var accessible = document.createElement('span'); accessible.className = 'visually-hidden'; bubble.appendChild(accessible); anchor.appendChild(bubble);
              }
              if (bubble) {
                bubble.hidden = !count;
                var visibleCount = bubble.querySelector('[aria-hidden="true"]');
                var hiddenCount = bubble.querySelector('.visually-hidden');
                if (visibleCount) visibleCount.textContent = count;
                if (hiddenCount) hiddenCount.textContent = count + (count === 1 ? ' item' : ' items');
              }
            });
          }).catch(function (error) { notice.textContent = error.message || 'Please check your basket before trying again.'; notice.hidden = false; })
          .finally(function () { button.disabled = false; button.removeAttribute('aria-busy'); button.innerHTML = label; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
